<div class="auth-page">
  <div class="auth-card">
    <div class="auth-header">
      <img alt="Logo" class="auth-logo" src="assets/logo.png" routerLink="/dashboard">
      <h2 class="auth-title mt-2">{{ 'register.title' | translate }}</h2>
      <p class="auth-subtitle">{{ 'register.subtitle' | translate }}</p>
    </div>
    <div class="auth-body">
      <!-- Success message -->
      <div *ngIf="registrationSuccess" class="text-center">
        <div class="success-icon mb-4">
          <i class="bi bi-check-circle fs-2 text-success"></i>
        </div>
        <h4 class="text-success mb-3">{{ 'register.success_title' | translate }}</h4>
        <p class="text-muted mb-4">{{ 'register.success_text' | translate }}</p>
        <button class="btn btn-primary btn-lg" (click)="goToLogin()">
          <i class="bi bi-box-arrow-in-right me-2"></i>{{ 'register.go_to_login' | translate }}
        </button>
      </div>

      <!-- Registration form -->
      <form *ngIf="!registrationSuccess" ngNativeValidate (ngSubmit)="onSubmit()">
        <!-- Error alert -->
        <div *ngIf="errorMessage" class="alert alert-danger mb-3">
          <i class="bi bi-exclamation-circle me-2"></i>{{ errorMessage }}
        </div>

        <div class="form-group mb-3">
          <label class="form-label"><i class="bi bi-person me-1"></i>{{ 'fullname' | translate }} *</label>
          <s-input type="text" name="fullname" [(model)]="data.fullname" [required]="true"
            [placeholder]="'register.fullname_placeholder' | translate"></s-input>
        </div>

        <div class="form-group mb-3">
          <label class="form-label"><i class="bi bi-at me-1"></i>{{ 'username' | translate }} *</label>
          <s-input type="text" name="username" [(model)]="data.username" [required]="true"
            [placeholder]="'register.username_placeholder' | translate"></s-input>
        </div>

        <div class="form-group mb-3">
          <label class="form-label"><i class="bi bi-envelope me-1"></i>{{ 'email' | translate }} *</label>
          <s-input type="email" name="email" [(model)]="data.email" [required]="true"
            [placeholder]="'register.email_placeholder' | translate"></s-input>
        </div>

        <div class="form-group mb-3">
          <label class="form-label"><i class="bi bi-lock me-1"></i>{{ 'password' | translate }} *</label>
          <s-input type="password" name="password" [(model)]="data.password" [required]="true"
            (modelChange)="onPasswordChange()"
            [placeholder]="'register.password_placeholder' | translate"></s-input>
        </div>

        <div class="form-group mb-3">
          <label class="form-label"><i class="bi bi-lock me-1"></i>{{ 'register.password_confirm' | translate }} *</label>
          <s-input type="password" name="passwordConfirm" [(model)]="data.passwordConfirm" [required]="true"
            (modelChange)="onPasswordChange()"
            [placeholder]="'register.password_confirm_placeholder' | translate"></s-input>
          <div *ngIf="passwordMismatch" class="text-danger small mt-1">
            {{ 'register.password_mismatch' | translate }}
          </div>
        </div>

        <hr class="my-4">
        <h5 class="mb-3"><i class="bi bi-building me-2"></i>{{ 'register.company_section' | translate }}</h5>

        <div class="form-group mb-3">
          <label class="form-label"><i class="bi bi-building me-1"></i>{{ 'register.company_name' | translate }} *</label>
          <s-input type="text" name="company_name" [(model)]="data.company_name" [required]="true"
            [placeholder]="'register.company_name_placeholder' | translate"></s-input>
        </div>

        <div class="form-group mb-4">
          <label class="form-label"><i class="bi bi-card-text me-1"></i>{{ 'register.ico' | translate }}</label>
          <s-input type="text" name="ico" [(model)]="data.ico"
            [placeholder]="'register.ico_placeholder' | translate"></s-input>
        </div>

        <div class="d-grid mb-3">
          <button class="btn btn-primary btn-lg" type="submit" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isLoading" class="bi bi-person-plus me-2"></i>
            {{ 'register.submit' | translate }}
          </button>
        </div>
        <div class="text-center">
          <span class="text-muted">{{ 'register.have_account' | translate }}</span>
          <a routerLink="/login" class="ms-2 text-decoration-none fw-bold">{{ 'register.sign_in' | translate }}</a>
        </div>
      </form>
    </div>
  </div>
</div>
